<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="info">
            <defs>
                <path id="wv7k3s2axa" d="M17.657 6.343C16.146 4.833 14.137 4 12 4s-4.146.832-5.657 2.343C4.833 7.854 4 9.863 4 12s.832 4.146 2.343 5.657C7.854 19.167 9.863 20 12 20s4.146-.832 5.657-2.343C19.167 16.146 20 14.137 20 12s-.832-4.146-2.343-5.657zM12 18.707c-3.698 0-6.707-3.009-6.707-6.707S8.302 5.293 12 5.293 18.707 8.302 18.707 12 15.698 18.707 12 18.707zm0-7.353c-.357 0-.646.29-.646.646v2.941c0 .357.29.647.646.647.357 0 .646-.29.646-.647V12c0-.357-.289-.646-.646-.646zm.457-2.752c-.12-.12-.287-.19-.457-.19-.17 0-.337.07-.457.19s-.19.286-.19.457c0 .17.07.336.19.457.12.12.287.189.457.189.17 0 .337-.07.457-.19s.19-.286.19-.456c0-.17-.07-.337-.19-.457z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask id="gl7wwuybnb" fill="#fff">
                    <use xlink:href="#wv7k3s2axa"/>
                </mask>
                <g class="path" :fill="fill" mask="url(#gl7wwuybnb)">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-info',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>